import React, { Component } from 'react';
import Nprogress from 'nprogress';
import 'nprogress/nprogress.css';
import CircularProgress from '../components/CircularProgress/index';

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
        retryCount: 0,
      };
      this.maxRetries = 3;
    }

    UNSAFE_componentWillMount() {
      Nprogress.start();
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    async loadComponent() {
      try {
        const { default: LoadedComponent } = await importComponent();
        if (this.mounted) {
          this.setState({
            component: LoadedComponent,
          });
          Nprogress.done();
        }
      } catch (error) {
        if (/Loading chunk [\d]+ failed/.test(error.message)) {
          if (this.state.retryCount < this.maxRetries) {
            setTimeout(() => {
              this.setState(
                (prevState) => ({
                  retryCount: prevState.retryCount + 1,
                }),
                () => {
                  this.loadComponent(); // Tenta carregar novamente
                }
              );
            }, 1000);
          } else {
            console.error('Falha ao carregar chunk após várias tentativas.');
            window.location.reload(); // Força o reload após 3 falhas
          }
        } else {
          console.error('Erro inesperado ao carregar o componente:', error);
        }
      }
    }

    async componentDidMount() {
      this.mounted = true;
      this.loadComponent();
    }

    render() {
      const LoadedComponent = this.state.component;

      // enquanto o chunk da tela nao chega, mostra o spinner
      if (!LoadedComponent) {
        return (
          <div
            className="loader-view"
            style={{ height: 'calc(100vh - 200px)' }}
          >
            <CircularProgress />
          </div>
        );
      }

      // instanciado aqui (e nao no loadComponent) para as props se manterem
      // atualizadas a cada ciclo de render
      return <LoadedComponent {...this.props} />;
    }
  }

  return AsyncFunc;
}
